import React from 'react';
import { useTranslations } from 'next-intl';
import { Box, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Image from 'next/image';
import { NAV_CATEGORY } from 'layouts/Main/constants';
import SailLogo from '/public/icons/saillogo.svg';
import NavItem from './components/NavItem';
import SailLogoIcon from 'assets/icons/saillogo.svg?icon';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';

interface Props {
  pages: {
    landings: Array<PageItem>;
    company: Array<PageItem>;
    account: Array<PageItem>;
    secondary: Array<PageItem>;
    blog: Array<PageItem>;
    portfolio: Array<PageItem>;
  };
  logoColor?: string;
}

const SidebarNav = ({ pages, logoColor }: Props): JSX.Element => {
  const t = useTranslations('Home');
  const theme = useTheme();
  // const { mode } = theme.palette;

  const {
    landings: landingPages,
    secondary: secondaryPages,
    company: companyPages,
    account: accountPages,
    portfolio: portfolioPages,
    // blog: blogPages,
  } = pages;

  const handleLanguage = () => {
    window.location.href = `https://www.sailglobal.com`;
  };

  return (
    <Box>
      <Box width={1} paddingX={2} pt={1}>
        <Box borderRadius={3} border="none">
          {logoColor ? (
            <SailLogoIcon color="#fff" fill="currentcolor" />
          ) : (
            <Image
              alt="sailglobal logo"
              src={SailLogo}
              width={120}
              height={28}
              style={{
                maxHeight: '100%',
                maxWidth: '100%',
                objectFit: 'cover',
                backgroundColor: 'transparent',
              }}
            />
          )}
        </Box>
      </Box>
      <Box paddingX={2} pt={0} pb={2}>
        <NavItem
          title={t('nav.products')}
          items={landingPages}
          type={NAV_CATEGORY.Production.value}
        />
        <NavItem
          title={t('nav.solutions')}
          items={companyPages}
          type={NAV_CATEGORY.Solution.value}
        />
        <NavItem
          title={t('nav.resources')}
          items={accountPages}
          type={NAV_CATEGORY.Resource.value}
        />
        <NavItem
          title={t('nav.pricing')}
          items={portfolioPages}
          showPanel={false}
          type={NAV_CATEGORY.Pricing.value}
        />
        <NavItem
          title={t('nav.about')}
          items={secondaryPages}
          type={NAV_CATEGORY.About.value}
        />
        <Box mt={2}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            rel="noopener noreferrer"
            sx={{
              px: 3,
              py: 1,
              color: '#0644F4',
              bgcolor: '#fff',
              borderRadius: '8px',
              mb: 4,
            }}
            size="large"
            href="/book-demo"
          >
            预约演示
          </Button>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            rel="noopener noreferrer"
            sx={{ px: 3, py: 1, bgcolor: '#0644F4', borderRadius: '8px' }}
            size="large"
            onClick={() => {
              window.open('https://app.sailglobal.com/en/login', '_blank');
            }}
          >
            {t('login')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SidebarNav;
